import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Input } from 'reactstrap';
import { Col, Row, Button, Label } from 'reactstrap';
import './checklist.style.css';
import SelectComponent from '@componentes/select/select.component';
import IntlMessage from '../../../../../../helpers/intlMessage';
import { injectIntl } from 'react-intl';

const ChecklistModalPage = (props) => {
    const { messages } = props.intl;
    return (
        <div className="checklist-container">
            <Modal size="lg" className="modal-checklist" isOpen={props.isOpen} toggle={props.toggle}>
                <ModalHeader toggle={props.toggle}><IntlMessage id="checklist.modalTitle" /></ModalHeader>
                <ModalBody>
                    <div style={{ height: `72vh`, width: '100%', overflowY: 'scroll', overflowX: 'hidden', minHeight: '450px' }}>
                        {
                            props.itens.map((item, key) => {
                                return <Row className='item-checklist' key={key}>
                                    <Col style={{ minWidth: '60%' }}>
                                        <div className="list-item-heading truncate w-80 mb-1 mt-1">
                                            <span className="heading-number d-inline-block">{key + 1}</span>
                                            <Label>{item.descricao}</Label>
                                        </div>
                                    </Col>
                                    <Col className="select-modal-checklist">
                                        {item.tipoResposta == 'date' ? <div>
                                            <Input type="date" value={item.value} ref={item.ref} placeholder="Resposta" onChange={(resp) => { props.salvarRespostaPergunta(item.id, resp.target.value) }}
                                                disabled={props.readonly} />
                                        </div> :
                                            item.tipoResposta == 'text' ? <div>
                                                <Input
                                                    type="text"
                                                    ref={item.ref}
                                                    placeholder={messages['checklist.resp']}
                                                    value={item.value}
                                                    onChange={(resp) => { props.salvarRespostaPergunta(item.id, resp.target.value) }}
                                                    disabled={props.readonly}
                                                />
                                            </div> :
                                                <SelectComponent
                                                    get
                                                    ref={item.ref}
                                                    placeholder="Resposta"
                                                    options={props.selectOptions}
                                                    value={item.value}
                                                    onChange={(resp) => { props.salvarRespostaPergunta(item.id, resp) }}
                                                    disabled={props.readonly}
                                                />}
                                    </Col>
                                </Row>
                            })
                        }
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={props.toggle}><IntlMessage id='dashboards.disposalMaterials.modal.cancel' /></Button>
                    {
                        !props.readonly && <Button color="primary" onClick={props.salvar} disabled={props.disableSalvar}>
                            <IntlMessage id="dashboards.examDetail.toSave"/>
                        </Button>
                    }
                </ModalFooter>
            </Modal>
        </div>
    )
}

export default injectIntl(ChecklistModalPage);


// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/material/tabs/checklist/checklist-modal.page.js